<template>
  <div class="row">
    <div class="col-lg-6 p-5 col-xs-12" style="background-color: #414141">
      <video
        v-show="url != false"
        width="100%"
        height="100%"
        id="video_show"
        controls
        controlslist="nodownload"
      >
        <source :src="url" />
      </video>
    </div>
    <div class="col-lg-6 col-xs-12 p-3 pr-5">
      <p>COMENTÁRIOS</p>
      <div class="mt-2 all_comments">
        <div
          class="f12 shadow_bar mt-2 mr-4 bg-white block_comment"
          v-for="com in comments"
          :key="com.id"
        >
          <div @click="deleteComments(com.id)" class="deleteComment bg-primary2 pointer right">
            <i class="fa fa-times"></i>
          </div>
          <span>
            <b>{{com.recruiter_name}}</b>
          </span>
          <br />
          <span class="conforta">{{com.description}}</span>
          <div class="text-right">
            <span class="small-text full">{{formattedDate(com.created_at)}}</span>
          </div>
        </div>
      </div>
      <StarRating
        active-color="#9472F8"
        @rating-selected="ratingSave"
        v-model="rating"
        v-bind:max-rating="5"
        v-bind:star-size="20"
      ></StarRating>
      <textarea
        class="form-control"
        v-model="comment"
        v-on:keyup.enter="saveComments"
        placeholder="COMENTE SOBRE ESSE VÍDEO, 'PRESSIONE ENTER PARA SALVAR'"
      ></textarea>
      <div>
        <button
          @click="nextCandidate(havePrevius(), -1)"
          :class="{hide: !havePrevius()}"
          class="btn mt-4 btn-primary left"
        >
          <i class="fas ml-2 fa-chevron-left"></i>
          Anterior
        </button>
        <button
          @click="nextCandidate(haveNext(), +1)"
          :class="{hide: !haveNext()}"
          class="btn mt-4 btn-primary right"
        >
          Próximo
          <i class="fas ml-2 fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import StarRating from "vue-star-rating";
export default {
  props: ["answer_id", "index", "videos"],
  components: { StarRating },
  data: () => ({
    rating: 0,
    url: "",
    comment: "",
    video_id: 0,
    index_current: 0,
    comments: [],
  }),
  mounted() {
    this.index_current = this.index;
    this.video_id = this.answer_id;

    this.makeVideoScreen();
    this.loadComments(this.video_id);
    this.rating = this.videos[this.index_current].rating;
    this.getRatingAgg();
  },
  methods: {
    deleteComments(comment_id) {
      let conf = confirm("Tem certeza que deseja deletar esse comentário?");

      if (!conf) {
        return;
      }
      axios.delete(`/recruiters/comments/${comment_id}`).then((response) => {
        this.loadComments(this.video_id);
      });
    },
    getRatingAgg(answer_id) {
      axios.get(`/recruiters/ratings/${answer_id}`).then((response) => {
        this.rating_agg = 0;
        if (response.data.rating) {
          this.rating = parseInt(response.data.rating);
          return;
        }
        this.rating = 0;
        return;
      });
    },
    haveNext() {
      if (this.videos[this.index_current + 1]) {
        return this.videos[this.index_current + 1];
      }
      return false;
    },
    havePrevius() {
      if (this.videos[this.index_current - 1]) {
        return this.videos[this.index_current - 1];
      }
      return false;
    },
    nextCandidate(apply, change) {
      if (!apply) return false;

      this.index_current = this.index_current + change;
      this.video_id = this.videos[this.index_current].id;
      this.makeVideoScreen();
      this.loadComments(this.video_id);
      this.getRatingAgg(this.video_id);
      let video = document.getElementById("video_show");
      video.load();
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    ratingSave() {
      axios
        .post("/recruiters/ratings", {
          ratings: {
            score: this.rating,
            answer_id: this.videos[this.index_current].id,
            apply_id: this.videos[this.index_current].apply_id,
          },
        })
        .then((response) => {
          this.$toast.success("Avaliação salva com sucesso");
        });
    },
    saveComments() {
      if (this.comment.length <= 3) {
        this.comment = "";
        this.$toast.error("Voce precisa digitar um comenario para salvar");
        return;
      }

      axios
        .post("/recruiters/comments", {
          comments: {
            description: this.comment,
            answer_id: this.videos[this.index_current].id,
            recruiter_id: 0,
          },
        })
        .then((response) => {
          this.comment = "";
          this.loadComments(this.videos[this.index_current].id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadComments(answer_id) {
      axios.get(`/recruiters/comments/${answer_id}/asc`).then((response) => {
        this.comments = response.data.comments;
      });
    },
    makeVideoScreen() {
      axios.get(`/recruiters/videos/${this.video_id}`).then((response) => {
        this.url = response.data.url;
        let video = document.getElementById("video_show");
        video.load();
      });
    },
  },
};
</script>

<style>
</style>